import React, { FunctionComponent, useCallback, useMemo } from "react";

import type { InvalidQuestionWarning } from ".";
import { AnswerTemplate } from "../../db/models/Answer";
import Question from "../../db/models/Question";
import { useTranslate } from "../translation/frontend";
import { QuestionTitle } from "./Question";

const ErrorSummary: FunctionComponent<{
  questions: Question[];
  warnings: InvalidQuestionWarning[];
  answers: Record<string, AnswerTemplate[]>;
}> = ({ questions, answers, warnings }) => {
  const translate = useTranslate();

  const handleOnClick = useCallback((event) => {
    event.preventDefault();
    const el = document.getElementById(`${new URL(event.currentTarget.href).hash.slice(1)}`);
    el?.scrollIntoView(true);
  }, []);

  // Sort the warnings into the order they appear on the page and de-dupe them
  const filteredWarnings = useMemo(() => {
    const filtered: InvalidQuestionWarning[] = [];
    for (const question of questions) {
      const questionWarnings = warnings.filter((warning) => warning.question === question);
      if (questionWarnings.length >= 1) filtered.push(questionWarnings[0]);
    }
    return filtered;
  }, [questions, warnings]);

  return (
    <div className="error-summary" aria-labelledby="error-summary-title" role="alert">
      <h2 className="error-summary__title" id="error-summary-title">
        {translate("errorSummaryTitle", { count: questions.length })}
      </h2>
      <div className="error-summary__body">
        <ul className="error-summary__list">
          {filteredWarnings.map(({ question, option }) => (
            <li key={question.id}>
              <a href={option ? `#${option.id}-other-error` : `#${question.id}-error`} onClick={handleOnClick}>
                <QuestionTitle question={question} answers={answers} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ErrorSummary;
